import { useCourierEntityHistoryTimeline } from '../../../../core/queries/entity-history.queries';

export function useCourierEntityHistory(courierID: string) {
  return useCourierEntityHistoryTimeline(courierID);
}
